import React from 'react';
import defaultImage from '../../assets/default-image.jpg'

const MediaNAchievment = ({organizer, baseURL}) => {
  return (
    <section className="company-fourth">
      <div className="container">
        <table className="table-borderless w-100" style={{marginBottom: '70px'}}>
          <tr>
            <td>
              <p className="mb-0" style={{fontSize: '14px', fontWeight: '600'}}>Media dan Prestasi</p>
            </td>
            <td className="tb" style={{width: '80%'}}>
              <div className="d-lg-block d-md-block d-sm-none d-none" style={{borderTop: '1px solid rgba(49, 49, 49, 0.12)', width: '100%'}}/>
            </td>
          </tr>
        </table>
        <div className="d-flex">
          {organizer.achievmentPictures ? organizer.achievmentPictures.map(e => (
            <img className="mr-5 mt-2" src={e.picture ? baseURL + '/'+ e.picture : defaultImage} alt="danamon-entrepreneur-awards" style={{width:'auto', height: '50px'}}/>
          )): null}
        </div>
        <div className="mb-5" style={{overflowX: 'auto'}}>
          <div className="row" style={{flexWrap: 'nowrap', marginTop: '60px'}}>
            {organizer.news ? organizer.news.map(e => (
              <a className="col-lg-3 col-md-3 col-sm-10 col-10" href={e.url} target="_blank" style={{color: 'black'}}><img className="mb-4" src={e.thumbnail ? baseURL + '/' + e.thumbnail : defaultImage} alt="cara-kerja-ttd-digital" style={{width: '100%', height: '160px', objectFit: 'cover'}} />
                <p style={{fontSize: '16px', fontWeight: '600'}}>
                  {e.title}
                </p>
              </a>
            )) : null}
          </div>
        </div>
        <a href={organizer.website} target="_blank" style={{fontSize: '14px', fontWeight: '600'}}>
          Lihat Berita Lainnya
        </a>
        <p className="mt-5">
        <a href="#" data-toggle="collapse" aria-expanded="false" aria-controls="collapse-sertifikasi" style={{fontSize: '14px', fontWeight: '600'}}>
          Lihat Sertifikasi
        </a>
        </p>
        <div className="collapse" id="collapse-sertifikasi"></div>
      </div>
    </section>
  )
}

export default MediaNAchievment;